
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 2H9.333A1.333 1.333 0 008 3.333V9l12 7 6 2.531L32 16V9z","fill":"#21a366"}}),_c('path',{attrs:{"fill":"#107c41","d":"M8 9h12v7H8z"}}),_c('path',{attrs:{"d":"M30.667 2H20v7h12V3.333A1.333 1.333 0 0030.667 2z","fill":"#33c481"}}),_c('path',{attrs:{"d":"M20 16H8v12.666A1.333 1.333 0 009.333 30h21.334A1.333 1.333 0 0032 28.666V23z","fill":"#185c37"}}),_c('path',{attrs:{"fill":"#107c41","d":"M20 16h12v7H20z"}}),_c('path',{attrs:{"d":"M16.667 7H8v19h8.667A1.337 1.337 0 0018 24.666V8.333A1.337 1.337 0 0016.667 7z","opacity":".1"}}),_c('path',{attrs:{"d":"M15.667 8H8v19h7.667A1.337 1.337 0 0017 25.666V9.333A1.337 1.337 0 0015.667 8z","opacity":".2"}}),_c('path',{attrs:{"d":"M15.667 8H8v17h7.667A1.337 1.337 0 0017 23.666V9.333A1.337 1.337 0 0015.667 8z","opacity":".2"}}),_c('path',{attrs:{"d":"M14.667 8H8v17h6.667A1.337 1.337 0 0016 23.666V9.333A1.337 1.337 0 0014.667 8z","opacity":".2"}}),_c('rect',{attrs:{"x":".001","y":"8","width":"15.999","height":"15.999","rx":"1.333","fill":"#107c41"}}),_c('path',{attrs:{"d":"M3.658 21L6.8 16.126l-2.877-4.847h2.318l1.573 3.1c.144.294.244.513.3.658h.02c.1-.235.213-.464.326-.685l1.681-3.071h2.128L9.312 16.1l3.03 4.9h-2.264l-1.817-3.4a2.881 2.881 0 01-.217-.454h-.027a2.188 2.188 0 01-.21.44L5.936 21z","fill":"#fff"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h32v32H0z"}})])
          )
        }
      }
    